// Registro del service worker, con el scope acotado a /bac — así NO
// interfiere con el resto de tu app (Login, /app, /sars, etc.), solo con
// el módulo de BAC Sarampión.
//
// El scope es "/bac" (SIN barra al final) a propósito: los navegadores
// comparan el scope como texto literal, y tu ruta real en React Router
// es exactamente "/bac" — con "/bac/" (con barra) esa página queda
// fuera del scope y el navegador no la controla.

const esLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1"
);

export function register() {
  if (!("serviceWorker" in navigator)) return;
  // Dentro del APK (Capacitor) los archivos ya vienen empaquetados en el
  // teléfono: el service worker sobra y solo complicaría las actualizaciones.
  if (window.Capacitor?.isNativePlatform?.()) return;
  if (window.location.protocol !== "https:" && !esLocalhost) return;

  // NUNCA se registra en "npm start" (desarrollo) — solo en el build de
  // producción ("npm run build"). Motivo: en desarrollo, el archivo JS
  // de la app se llama siempre igual (sin un código único por cada
  // cambio, eso solo existe en el build de producción) — un service
  // worker cache-first sobre eso se queda pegado sirviendo la PRIMERA
  // versión que cacheó para siempre, sin importar cuántas veces edites
  // el código y reinicies el servidor. Con esta línea, "npm start"
  // jamás instala un service worker, así que nunca puede pasar.
  if (process.env.NODE_ENV !== "production") {
    console.log("ℹ️ Service worker desactivado en desarrollo (npm start) a propósito.");
    return;
  }

  window.addEventListener("load", () => {
    const swUrl = "/service-worker.js";
    navigator.serviceWorker
      .register(swUrl, { scope: "/bac" })
      .then((registration) => {
        console.log("✅ Service worker de BAC Sarampión registrado:", registration.scope);

        // Revisa activamente si hay una versión nueva cada vez que se
        // entra a la app — no espera a que el navegador lo haga solo
        // (que a veces tarda días en notarlo).
        registration.update().catch(() => {});
      })
      .catch((error) => {
        console.error("❌ Error registrando el service worker:", error);
      });

    // ── Auto-recarga cuando hay una versión nueva ───────────────────
    // Sin esto, alguien que deja la app abierta varios días (sin
    // cerrarla del todo) se queda corriendo el código viejo en memoria
    // PARA SIEMPRE. Pero si la recarga te agarra a mitad de un
    // formulario, perdés lo que llevabas escrito — por eso, si hay un
    // modal abierto (ver modalTracker.js), se ESPERA a que lo cierres
    // para recargar, en vez de hacerlo de una.
    let yaRecargando = false;
    let recargaPendiente = false;

    const intentarRecargar = () => {
      if (yaRecargando) return;
      if (window.__bacModalAbierto) {
        recargaPendiente = true;
        console.log("🔄 Nueva versión detectada — se aplicará cuando cierres el formulario actual.");
        window.dispatchEvent(new CustomEvent("bac-actualizacion-esperando"));
        return;
      }
      yaRecargando = true;
      console.log("🔄 Nueva versión detectada — recargando...");
      window.dispatchEvent(new CustomEvent("bac-actualizacion-aplicando"));
      window.location.reload();
    };

    navigator.serviceWorker.addEventListener("controllerchange", intentarRecargar);

    // Apenas se cierra un modal, si había una recarga esperando, se
    // dispara recién ahí — nunca a mitad de la captura de datos.
    window.addEventListener("bac-modal-cerrado", () => {
      if (recargaPendiente) intentarRecargar();
    });

    // ── Válvula de seguridad ─────────────────────────────────────────
    // Si por lo que sea la bandera "hay un modal abierto" se queda mal
    // puesta (un bug, un caso raro no contemplado), esto evita que la
    // recarga quede esperando PARA SIEMPRE sin que nadie se entere —
    // a los 5 minutos, se fuerza la recarga de todas formas.
    setInterval(() => {
      if (recargaPendiente && !yaRecargando) {
        console.log("🔄 Recarga pendiente hace rato — se fuerza por seguridad.");
        window.__bacModalAbierto = false;
        intentarRecargar();
      }
    }, 5 * 60 * 1000);
  });
}

export function unregister() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister();
  });
}